import { render, staticRenderFns } from "./BabylonPanel.vue?vue&type=template&id=1c5f0f44&scoped=true"
import script from "./BabylonPanel.vue?vue&type=script&lang=js"
export * from "./BabylonPanel.vue?vue&type=script&lang=js"
import style0 from "./BabylonPanel.vue?vue&type=style&index=0&id=1c5f0f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f0f44",
  null
  
)

export default component.exports